import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { adminLogin } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const LOGO = 'https://customer-assets.emergentagent.com/job_87cd0f70-4f18-4348-a2fd-e2666a61734d/artifacts/ozrawt0t_IMG_0439.jpeg';

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('nayemurofficial@gmail.com');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { document.title = 'AlveeTrade Admin — Login'; }, []);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email.trim(), password);
      toast.success('Welcome back, Admin.');
      nav('/admin/nayemur/alvee');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen relative overflow-hidden bg-[hsl(0_0%_4%)] flex items-center justify-center px-4 hero-glow noise-overlay">
      <div className="w-full max-w-md relative z-10">
        <div className="flex items-center justify-center gap-3 mb-6">
          <img src={LOGO} alt="AlveeTrade" className="h-11 w-11 rounded-xl gold-hairline" />
          <div className="font-display uppercase text-3xl tracking-wide">AlveeTrade</div>
        </div>
        <Card className="card-surface shadow-[0_20px_60px_rgba(0,0,0,0.55)]">
          <CardHeader>
            <CardTitle className="text-xl">Admin Login</CardTitle>
            <p className="text-sm text-muted-foreground">Sign in to manage pixels, videos, and analytics.</p>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
              </div>
              <Button type="submit" disabled={loading} className="w-full cta-sheen h-11 font-semibold text-white border-0" data-testid="admin-login-submit-button">
                {loading ? 'Signing in…' : 'Sign in'}
              </Button>
            </form>
            <p className="text-xs text-muted-foreground mt-4 text-center">Authorized personnel only.</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
